// Pixel Twist

// Site CSS.
// import '@fortawesome/fontawesome-pro/css/fontawesome.min.css'
// import '@fortawesome/fontawesome-pro/css/brands.min.css'
// import '@fortawesome/fontawesome-pro/css/regular.min.css'
// import '@fortawesome/fontawesome-pro/css/solid.min.css'
// import '@fortawesome/fontawesome-pro/css/light.min.css'
// import '@fortawesome/fontawesome-pro/css/all.min.css'
// import 'flexigridcss/dist/flexigridcss/container-grid.css'
// import 'flexigridcss/dist/flexigridcss/container.css'
// import 'flexigridcss/dist/flexigridcss/columns.css'
// import 'flexigridcss/dist/flexigridcss/row.css'
// import 'flexigridcss/dist/flexigridcss/modifiers.css'
// import 'hamburgers/dist/hamburgers.min.css'
// import 'swiper/dist/css/swiper.min.css'
import 'flexigridcss/dist/flexigridcss.min.css';
import '../sass/style.scss'
// Site JS //
import '@fortawesome/fontawesome-pro/js/fontawesome.min'
// import '@fortawesome/fontawesome-pro/js/all.min'
import {domReady} from './utilities/helpers'
import setup from './setup'
import '@fortawesome/fontawesome-pro/js/brands.min'
import '@fortawesome/fontawesome-pro/js/regular.min'
import '@fortawesome/fontawesome-pro/js/solid.min'
// import '@fortawesome/fontawesome-pro/js/light.min'

function start() {
  setup();
}

domReady(start);
